import { render, staticRenderFns } from "./orderServicerAddMy.vue?vue&type=template&id=0d6449af&"
import script from "./orderServicerAddMy.vue?vue&type=script&lang=ts&"
export * from "./orderServicerAddMy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports